import { Question } from '../../models/Quiz';

export const randomUUID = () => {
  // Obter o timestamp atual
  const timeStamp = Date.now();

  // Se o `performance.now()` estiver disponível, podemos melhorar a aleatoriedade
  const performanceTime =
    typeof performance !== 'undefined' && performance.now
      ? performance.now()
      : 0;

  // Gerar um array de 16 bytes com valores aleatórios
  const array = new Uint8Array(16);
  crypto.getRandomValues(array);

  // Incluir a hora e o `performance.now()` na mistura de aleatoriedade
  /* eslint-disable-next-line no-bitwise */
  array[0] = (array[0] + (timeStamp & 0xff)) & 0xff;
  /* eslint-disable-next-line no-bitwise */
  array[1] = (array[1] + ((timeStamp >> 8) & 0xff)) & 0xff;
  /* eslint-disable-next-line no-bitwise */
  array[2] = (array[2] + ((timeStamp >> 16) & 0xff)) & 0xff;
  /* eslint-disable-next-line no-bitwise */
  array[3] = (array[3] + ((timeStamp >> 24) & 0xff)) & 0xff;

  // Usando `performance.now()` para adicionar mais aleatoriedade
  /* eslint-disable-next-line no-bitwise */
  array[4] = (array[4] + (performanceTime & 0xff)) & 0xff;
  /* eslint-disable-next-line no-bitwise */
  array[5] = (array[5] + ((performanceTime >> 8) & 0xff)) & 0xff;

  // Modifica o byte 6 para marcar a versão do UUID (versão 4)
  /* eslint-disable-next-line no-bitwise */
  array[6] = (array[6] & 0x0f) | 0x40; // versão 4
  // Modifica o byte 8 para marcar a variante (RFC 4122)
  /* eslint-disable-next-line no-bitwise */
  array[8] = (array[8] & 0x3f) | 0x80; // variante RFC4122

  // Converte os bytes para o formato UUID
  const uuid = [...array]
    .map((b, i) => {
      const hex = b.toString(16).padStart(2, '0');
      return (i === 4 || i === 6 || i === 8 || i === 10 ? '-' : '') + hex;
    })
    .join('');

  return uuid;
};

export const handleListenQuestion = (
  question: Question,
  listening: boolean,
  setListening: (status: boolean) => void,
) => {
  setListening(!listening);
  if (listening) {
    window.speechSynthesis.cancel();
    return;
  }

  const splitText = (text: string, maxLength: number) => {
    let result = text || '';
    const parts = [];
    while (result.length > maxLength) {
      let splitIndex = result.lastIndexOf('.', maxLength);
      if (splitIndex === -1) {
        splitIndex = maxLength;
      }
      parts.push(result.substring(0, splitIndex + 1));
      result = result.substring(splitIndex + 1).trim();
    }
    if (result.length > 0) {
      parts.push(result);
    }
    return parts;
  };

  const text = `${question.description}...
    Alternativa A: ${question.optionA}...
    Alternativa B: ${question.optionB}...
    Alternativa C: ${question.optionC}...
    Alternativa D: ${question.optionD}
  `;

  const parts = splitText(text, 120);

  if ('speechSynthesis' in window) {
    window.speechSynthesis.cancel();
    let currentIndex = 0;

    const speakNextPart = () => {
      if (currentIndex < parts.length) {
        const utterance = new SpeechSynthesisUtterance(parts[currentIndex]);
        utterance.lang = 'pt-BR';
        utterance.rate = 1;
        utterance.pitch = 1;

        utterance.onend = () => {
          currentIndex += 1;
          speakNextPart();
        };

        window.speechSynthesis.speak(utterance);
        return;
      }
      setListening(false);
    };
    speakNextPart();
  } // else {
  //   addToast({
  //     type: 'error',
  //     title: 'Erro ao falar',
  //     description: 'Seu navegador não suporta a funcionalidade de fala',
  //   });
  // }
};
